import { render, staticRenderFns } from "./SwitchPartnerView.vue?vue&type=template&id=6dd32be2&"
import script from "./SwitchPartnerView.vue?vue&type=script&lang=js&"
export * from "./SwitchPartnerView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports